module.exports = __webpack_public_path__ + "img/business-solutions-hero@2x.ead8cef2.webp";